import React from 'react';

interface ThemeIconProps {
  color: string;
  size?: number;
}

export const ThemeIcon: React.FC<ThemeIconProps> = ({ color, size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3328 3C12.4648 3 12.5958 3 12.7258 3C11.4411 4.19371 10.6154 5.79985 10.3921 7.53923C10.1688 9.2786 10.562 11.0412 11.5035 12.5207C12.445 14.0002 13.8752 15.103 15.5454 15.6375C17.2156 16.1719 19.0203 16.1042 20.6458 15.446C20.0205 16.9505 18.9986 18.257 17.689 19.2263C16.3794 20.1955 14.8312 20.791 13.2097 20.9494C11.5882 21.1077 9.95405 20.823 8.48168 20.1254C7.00931 19.4279 5.7539 18.3437 4.84938 16.9886C3.94485 15.6335 3.42514 14.0583 3.34567 12.431C3.26621 10.8037 3.62997 9.1853 4.39816 7.74852C5.16635 6.31174 6.31015 5.11043 7.70755 4.27274C9.10495 3.43505 10.7035 2.9924 12.3328 2.992V3Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
